import { render, staticRenderFns } from "./CountryPicker.vue?vue&type=template&id=04d63c05&scoped=true"
import script from "./CountryPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./CountryPicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CountryPicker.vue?vue&type=style&index=0&id=04d63c05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d63c05",
  null
  
)

export default component.exports